import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-standard',
  templateUrl: './edit-standard.component.html',
  styleUrls: ['./edit-standard.component.css']
})
export class EditStandardComponent implements OnInit {
  gogo = '';
  standardObj: any = {};
  filesList: any[] = [];
  usersList: any[] = [];
  activeStep = 1; // 1, 2, 3;
  nextButText = 'Next';
  questionList: any[] = [];

  constructor() {
  }

  ngOnInit() {
    this.filesList = [
      {
        id: 'asd45',
        name: 'ERTY-S7895',
        number: '7864'
      },
      {
        id: '78efg',
        name: 'VBNM-Z9632',
        number: '0014'
      }
    ];
    // get users;
    this.usersList = [
      {
        id: 'ds5f456sd',
        firstName: 'MarK',
        lastName: 'Twen'
      },
      {
        id: '5sdf45',
        firstName: 'Arnold',
        lastName: 'Chan'
      },
    ];
    // get standard;
    this.standardObj = {
      id: 'asdas54df5sd7f5s',
      number: '2584',
      author: 'Arnold Chan',
      status: 'INACTIVE',
      titleRu: 'РЎС‚Р°РЅРґР°СЂС‚ Р”Р Рњ',
      titleEn: 'DRM Standard',
      annotationRu: 'РЈРїСЂР°РІР»РµРЅРёРµ Р”Р Рњ СЃРёСЃС‚РµРјРѕР№',
      annotationEn: 'DRM System controll',
      typeRu: 'РЎРёСЃС‚РµРјРЅС‹Р№',
      typeEn: 'System'
      // AND questions list, files list, (users, positions, groups lists);
    };

  }

  goToStepOne() {
    this.activeStep = 1;
    this.nextButText = 'Next';
  }

  goToStepTwo() {
    this.activeStep = 2;
    this.nextButText = 'Next';
  }

  goToStepThree() {
    this.activeStep = 3;
    this.nextButText = 'Ok, create';
  }

  goToPrev() {
    if (this.activeStep > 1) {
      this.activeStep--;
      this.nextButText = 'Next';
    }
    if (this.activeStep < 1) {
      this.activeStep = 1;
    }
  }

  goToNext() {
    if (this.activeStep < 3) {
      this.activeStep++;
    }
    if (this.activeStep > 3) {
      this.activeStep = 3;
    }
    if (this.activeStep === 3) {
      this.nextButText = 'Ok, create';
    }
  }

  addQuestionToList() {
    this.questionList.push(
      {
        questionTextRu: '',
        questionTextEn: '',
        rightAnswerRu: '',
        rightAnswerEn: '',
        answers: [
          {
            answerOneRu: '',
            answerTwoRu: '',
            answerThreeRu: '',
            answerOneEn: '',
            answerTwoEn: '',
            answerThreeEn: '',
          }
        ]
      }
    );
  }

  deleteQuestionFromList(key) {
    if (key > -1) {
      this.questionList.splice(key, 1);
    }
  }

  deleteFile(fileID) {
    // delete file by ID
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/edit-standard/edit-standard.component.ts